<template>
    <div v-loading="loading.page" class="service-manage-ctn">
        <top-tip>
            <div>
                后端服务接口，可以打通多方数据或调用开放的服务。只需填写少量信息即可在应用内调用。更多详情请
                <hc-link :underline="false" type="primary" href="https://open.mingyuanyun.com/knowledge/mpaas/8ecabbcd-f57b-4d88-bd76-3fa41318cad2" target="_blank">
                    查看文档
                </hc-link>。
            </div>
        </top-tip>
        <div class="service-manage">
            <div class="service-group">
                <Group
                    :is-dev-env="isDevEnv"
                    :group-arr="groupArr"
                    :api-param-obj="apiParamObj"
                    :var-obj="varObj"
                    :filter-obj="filterObj"
                    @select-group="selectGroupFn"
                    @edit-group="editGroupFn"
                    @handle-click="handleClick"
                    @add-group="addGroupFn"
                    @add-group-dialog="addGroupDialogFn"
                />
            </div>
            <div class="service-list">
                <div class="service-list-header">
                    <div class="service-list-header-H1">
                        后端操作管理
                    </div>
                    <div class="service-list-header-search">
                        <hc-input v-model="filterObj.keyword" placeholder="请输入搜索关键词" @keyup.enter.native="getGroupServiceFnBySearch">
                            <span
                                slot="suffix"
                                class="hc-icon-search hc-input__icon"
                                @click="getGroupServiceFnBySearch"
                            />
                        </hc-input>
                    </div>
                    <span class="service-list-header-spliter" />
                    <hc-button v-if="appInfo.xingtuEnable === 1" class="service-list-header-update" @click="showUpdateApiDialog">
                        更新全部
                    </hc-button>
                    <div class="service-list-header-add">
                        <hc-button
                            v-if="isTenantApp ? validPurviewService.addService : true"
                            plain
                            @click="addServiceVisible = true"
                        >
                            新建后端操作
                        </hc-button>
                    </div>
                </div>
                <hc-table ref="elTable" v-loading="loading.table" :data="serviceArr" :class="`table-wrapper${filterObj.total > 0 ? '' : '__no-data'}`" :height="filterObj.total > 0 ? 'calc(100% - 108px)' : 'calc(100% - 48px)'">
                    <div slot="empty" class="table-empty">
                        <img :src="EmptyIcon" alt="">
                        <div class="table-empty-tip">
                            暂无后端操作,
                            <span class="table-empty-button" @click="addServiceVisible = true">立即添加</span>
                        </div>
                    </div>

                    <hc-table-column label="序号" type="index" width="min-width" min-width="6%" />

                    <hc-table-column label="显示名称" width="min-width" min-width="23%">
                        <template slot-scope="{ row }">
                            <div style="display: flex; align-items: center">
                                <hc-tooltip effect="dark" :content="row.title" placement="top">
                                    <span :class="['title', 'table-wrapper--displayname', {'hidden-part': row.isUpdate}]">{{ row.title }}</span>
                                </hc-tooltip>
                                <hc-button
                                    v-if="row.isUpdate && row.isXingTu"
                                    :loading="updateLoading && row.id === currentApiId"
                                    type="text"
                                    style="margin-left:8px;font-weight: 400;padding: 3px 0;font-size: 13px;"
                                    @click="updateApi(row)"
                                >
                                    更新
                                </hc-button>
                            </div>
                        </template>
                    </hc-table-column>

                    <hc-table-column
                        v-for="item in columns"
                        :key="item.prop"
                        :prop="item.prop"
                        :label="item.label"
                        :width="item.width ? item.width : item.minWidth ? 'min-width' : ''"
                        :min-width="item.minWidth ? item.minWidth : item.width === 'min-width' ? '200' : 'auto'"
                    >
                        <template slot-scope="{ row }">
                            <span v-if="!row[item.prop]"> -- </span>
                            <div v-else>
                                <text-over-tooltip ref-name="remarkprop"
                                    :content="row[item.prop]"
                                />
                            </div>
                        </template>
                    </hc-table-column>

                    <hc-table-column label="操作" width="min-width" min-width="12%">
                        <template slot-scope="{ row }">
                            <hc-button
                                :loading="editLoadingId === row.id" type="text" :disabled="!isDevEnv" @click="openDialogFn('编辑',row)"
                            >
                                编辑
                            </hc-button>
                            <span class="decollator" />
                            <hc-button v-if="isTenantApp ? row.isTenant : true" type="text" :disabled="!isDevEnv" @click="delServiceFn(row)">
                                删除
                            </hc-button>
                        </template>
                    </hc-table-column>
                </hc-table>
                <div v-if="filterObj.total > 0" class="pagination-wrapper">
                    <hc-pagination
                        class="pagination-wrapper has-top-border"
                        :current-page.sync="filterObj.page"
                        :page-size="filterObj.pageSize"
                        layout="total, prev, pager, next, sizes, jumper"
                        :total="filterObj.total"
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                    />
                </div>
                <hc-dialog
                    title="新建后端操作"
                    width="720px"
                    top="120px"
                    :visible.sync="addServiceVisible"
                >
                    <div class="add-service-modal">
                        <div
                            v-for="item in serviceType"
                            :key="item.key"
                            class="add-service-modal-item"
                            :title="item.title"
                            @click="addServiceByType(item)"
                        >
                            <img class="img" :src="item.img">
                            <div class="title">
                                {{ item.title }}
                            </div>
                            <div class="des">
                                {{ item.des }}
                            </div>
                        </div>
                    </div>
                    <div slot="footer" class="add-service-modal-footer">
                        请选择添加方式或查看<a style="color: #266EFF" target="_blank" href="https://open.mingyuanyun.com/docs/mpaas/latest/AppSource/Services/Service">帮助文档</a>
                    </div>
                </hc-dialog>
                <import-Dialog v-if="showImportDialog" :save-callback="onImportEvent" :dialog-visible.sync="showImportDialog" :tree-config="treeConfig" @closeDialog="closeImportDialog" />
                <!-- 更新进度的弹窗 -->
                <hc-dialog title="更新全部" width="720px" top="160px" :visible.sync="updateApiVisible" class="service-manage-ctn__update-dialog"
                    :before-close="handleUpdateDialogClose"
                    :close-on-click-modal="false"
                >
                    <!-- loading icon  -->
                    <div v-if="updateApiLoading" class="update-loading">
                        <hc-icon class="el-icon-loading" />
                        <div v-if="updateApiList.length" class="loading-tip">
                            更新中，请稍候({{ Number(updateInfo.success) + Number(updateInfo.fail) }}/{{ updateApiList.length }})...
                        </div>
                    </div>
                    <!-- 更新成功 -->
                    <div v-else :class="`update-success ${!updateApiList.length ?'update-success--empty':''}`">
                        <img :src="updateInfo.icon" :alt="updateInfo.text">
                        <div class="update-success-tip">
                            {{ updateInfo.text }}
                        </div>
                        <!-- 更新成功/失败的数量 -->
                        <div v-if="updateApiList.length" class="update-success-num">
                            更新成功：{{ updateInfo.success }} <br>
                            更新失败：{{ updateInfo.fail }}，{{ updateInfo.fail > 0 ? '失败接口请手动更新' : '' }}
                        </div>
                        <!-- 完成按钮 -->
                        <div class="update-success-btn">
                            <hc-button type="primary" @click="handleUpdateSuccess">
                                完成
                            </hc-button>
                        </div>
                    </div>
                </hc-dialog>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions } from 'vuex'
import { logger } from '@mypaas/app-render-engine/core/sdk'
import * as T from '@common/store/app-resource/types'
import * as ST from '@common/store/types'
import _ from 'lodash'
import TopTip from '@common/components/common/top-tip'
import { APP_RESOURCE, STAR_MAP } from '@common/store/module-types'
import {
    GET_MIP_API_DETAIL, UPDATE_STAR_MAP_INFO, UPDATE_STAR_MIP_API, UPDATE_STAR_MIP_API_LIST,
} from '@common/store/star-map/types'
import { getObjectField } from '@common/api/app-resource'
import textOverTooltip from '@common/components/common/text-over-tooltip'
import EmptyIcon from '@common/assets/img/empty.svg'
import PlatformApiIcon from '@common/assets/img/platform-api.png'
import CustomApiIcon from '@common/assets/img/custom-api.png'
import OfflineApiIcon from '@common/assets/img/offline-api.png'
import SuccessIcon from '@common/assets/img/icon_success.svg'
import DefaultWarningIcon from '@common/assets/img/icon_default_warning.png'
import EnvList from '../mixins/env-list'
import DataServiceMinxin from '../mixins/data-service'
import Group from '../components/service-group'

const DEFAULT_UPDATE_API_INFO = {
    icon: DefaultWarningIcon,
    text: '暂无需要更新的api',
    success: 0,
    fail: 0,
}
export function fieldTransform({
    name, required, sourceType, title, type, remark, handle,
}) {
    return {
        key: name || title,
        value: '',
        type,
        sourceType,
        required,
        objectId: '',
        isTenant: false,
        customizeType: 0,
        customizeField: '',
        addField: false,
        remark,
        handle: handle || 'pair',
    }
}

export function isParamsType(type) {
    return /(form-data|x-www-form-urlencoded|application\/octet-stream)/i.test(type)
}

export default {
    name: 'ServiceManagement',
    components: {
        textOverTooltip,
        Group,
        TopTip,
    },
    mixins: [EnvList, DataServiceMinxin],
    data() {
        return {
            EmptyIcon,
            SuccessIcon,
            DefaultWarningIcon,
            currentApiId: '',
            updateLoading: false,
            updateApiLoading: false,
            updateApiVisible: false,
            showAddgroup: false,
            addInput: '',
            varObj: { requestBody: 'formData' },
            groupArr: [],
            dialogFormType: 'customCreated',
            columns: [
                { prop: 'url', label: '请求地址', minWidth: '23%' },
                { prop: 'createdAt', label: '创建时间', minWidth: '18%' },
                { prop: 'updatedAt', label: '更新时间', minWidth: '18%' },
            ],
            paramsTypeArr: [
                {
                    name: 'HTTP Headers',
                    value: 'headers',
                },
                {
                    name: 'Querys',
                    value: 'querys',
                },
                {
                    name: 'Request',
                    value: 'Request',
                },
                {
                    name: 'HTTP Headers',
                    value: 'headers',
                },
            ],
            filterObj: {
                keyword: '',
                groupId: '',
                page: 1,
                pageSize: 10,
            },
            objectForm: {
                objectId: '',
            },
            apiParamObj: {
                isXingTu: false,
                type: 'customCreate', // customCreate ｜ xingTuApi | offlineService
            }, // 请求接口的参数
            tableFormObj: {
                tableDataArr: [],
            },
            apiParamObjResponseDefault: {
                codeName: 'success',
                successCodeValue: 'true',
                msgName: 'error.exception.message',
                dataName: 'result',
                totalName: 'result.total',
                dataType: '',
                isMock: false,
                mockData: '',
            },
            serviceArr: [],
            defaultServiceArr: [], // 接口请求获取到的服务列表的原始数据
            appId: '',
            loading: {
                page: false,
                dialog: false,
                modal: false,
            },
            editLoadingId: '',
            addServiceVisible: false,
            serviceType: [
                {
                    key: 'xingTuApi',
                    img: PlatformApiIcon,
                    title: '集成开放平台API',
                    des: '集成开放平台的服务 API 和服务流，一键添加到平台',
                }, {
                    key: 'custom',
                    img: CustomApiIcon,
                    title: '第三方',
                    des: '第三方服务接口，支持空白创建或文件解析创建',
                }, {
                    key: 'offline',
                    img: OfflineApiIcon,
                    title: '离线服务',
                    des: '云链离线业务专有，其他业务需要按需使用',
                },
            ],

            updateInfo: DEFAULT_UPDATE_API_INFO,
            updateApiList: [],
            updateTimer: null,
        }
    },
    computed: {
        isTenantApp() {
            return this.$store.state.modeling.app.isTenant
        },
        validPurviewService() {
            return this.$store.state.modeling.validPurview.service || {}
        },
        appInfo() {
            return this.$store.state.modeling.app
        },
        validPurviewObject() {
            return this.$store.state.modeling.validPurview.object || {}
        },
        current() {
            return this.$store.state.WORKSPACE.current
        },
        xingtuInfo() {
            return this.current.xingtuInfo || {}
        },
        xingTuEnvId() {
            return this.xingtuInfo.xingTuEnvId
        },
        
    },
    watch: {
        // 关闭/取消编辑窗口后，清除未保存的数据（还原为初开数据）
        'varObj.optBool'(val) {
            const { serviceArr, defaultServiceArr } = this
            if (!val && !_.isEqual(serviceArr, defaultServiceArr)) {
                this.serviceArr = _.cloneDeep(this.defaultServiceArr)
            }
        },

        updateApiVisible(val) {
            if (!val) {
                clearTimeout(this.updateTimer)
            }
            this.updateApiList = []
        },
    },
    created() {
        // 提前加载拼音库
        import('pinyin/lib/pinyin').then()
    },
    mounted() {
        this.appId = this.$route.params.appId
    },

    unMounted() {
        clearTimeout(this.updateTimer)
    },

    methods: {
        ...mapActions(APP_RESOURCE, {
            getServiceGroup: T.GET_NEW_SERVICE_GROUP,
            addServiceGroup: T.ADD_NEW_SERVICE_GROUP,
            editServiceGroup: T.EDIT_NEW_SERVICE_GROUP,
            delServiceGroup: T.DEL_NEW_SERVICE_GROUP,
            getService: T.GET_NEW_SERVICE,
            addService: T.ADD_NEW_SERVICE,
            editService: T.EDIT_NEW_SERVICE,
            delService: T.DEL_NEW_SERVICE,
            getObject: T.GET_NEW_OBJECT,
            getObjectDtl: T.GET_NEW_OBJECT_DTL,
            importService: T.IMPORT_SERVICE,
            closeMockAction: T.CLOSE_MOCK,
        }),
        ...mapActions(STAR_MAP, {
            // TODO: 编排功能不用调整
            getMipApiDetail: GET_MIP_API_DETAIL,
            updateStarMapInfo: UPDATE_STAR_MAP_INFO,
            updateStarMipApiList: UPDATE_STAR_MIP_API_LIST,
            updateStarMipApi: UPDATE_STAR_MIP_API,
        }),
        ...mapActions({
            getValidPurview: ST.GET_VALID_PURVIEW,
        }),
        updateApi(row) {
            // 如果API来源已经删除 => 触发删除逻辑
            if (row.isDeleted) {
                this.$confirm('当前接口已在集成开放平台下线，请确认是否删除？', {
                    type: 'warning',
                    title: '提示',
                    customClass: 'confirm-box',
                    roundButton: false,
                })
                    .then(async () => {
                        try {
                            await this.delService({
                                serviceId: row.id,
                            })
                            this.$message.success('删除成功')
                            this.getGroupServiceFn()
                            // eslint-disable-next-line no-empty
                        } catch (error) {}
                    })
                    .catch(() => {})
            } else {
                this.currentApiId = row.id
                this.updateLoading = true
                if (!this.xingTuEnvId) {
                    const { businessEnv = {} } = this.appInfo
                    const { category } = businessEnv
                    const envMap = {
                        dev: '开发环境',
                        prod: '生产',
                        test: '测试',
                        beta: '预发布',
                    }
                    this.$message.error(`请完成${envMap[category] || '该'}环境下的环境变量【集成开放平台域名】的值`)
                    return
                }
                const { xingTuEnvId } = this
                const { manageKey = '' } = this.xingtuInfo
                this.updateStarMapInfo({
                    id: row.id,
                    xingTuEnvId,
                    manageKey,
                }).then(res => {
                    if (res && res.isToast) {
                        this.$message.success('此服务 API 已被删除')
                    } else {
                        this.$message.success('更新成功')
                    }

                    this.getGroupServiceFn()
                }).finally(() => {
                    this.updateLoading = false
                    this.currentApiId = ''
                })
            }
        },
        // 查询分组
        async getServiceGroupFn(loading = true) {
            try {
                this.loading.page = loading
                this.groupArr = await this.getServiceGroup()
                await this.selectGroupFn(0)
                this.loading.page = false
            } catch (error) {
                this.loading.page = false
            }
        },
        // 选中分组
        selectGroupFn(id) {
            this.$set(this.filterObj, 'groupId', id)
            this.filterObj.page = 1
            if (!this.filterObj.groupId) {
                delete this.filterObj.groupId
            }
            this.getGroupServiceFn()
        },
        closeMock() {
            this.$confirm('该操作将关闭所有开启了Mock功能的服务API，请确认是否继续该操作', {
                type: 'warning',
                title: '关闭Mock',
                customClass: 'confirm-box',
                roundButton: false,
            }).then(() => {
                this.closeMockAction().then(() => {
                    this.$message.success('关闭成功')
                    this.getGroupServiceFn()
                })
            }).catch(() => {

            })
        },
        addGroupDialogFn() {
            if (!this.isDevEnv) return
            this.$set(this.varObj, 'addGroupBool', true)
            this.$nextTick(() => {
                this.$refs.addGroupInput && this.$refs.addGroupInput.focus()
            })
            this.apiParamObj = {}
        },
        async addGroupbySelect() {
            try {
                if (!this.addInput) {
                    return
                }
                this.addInput = this.addInput.replace(/\s/g, '')
                await this.addServiceGroup({ title: this.addInput })
                this.addInput = ''
                this.showAddgroup = false
                this.getServiceGroupFn(false)
                this.loading.page = false
            } catch (error) {
                this.loading.page = false
            }
        },
        // 新增分组
        async addGroupFn() {
            try {
                if (!this.apiParamObj.title) {
                    this.$set(this.varObj, 'addGroupBool', false)
                    this.$message.error('分组名称不可为空')
                    return
                }
                this.apiParamObj.title = this.apiParamObj.title.replace(/\s/g, '')
                this.loading.page = true
                await this.addServiceGroup(this.apiParamObj)
                this.apiParamObj = {}
                this.$set(this.varObj, 'addGroupBool', false)
                this.getServiceGroupFn()
                this.loading.page = false
            } catch (error) {
                this.loading.page = false
            }
        },
        handleClick(val, item) {
            if (val === 'delete') {
                this.delGroupFn(item.id)
            } else {
                this.$set(this.varObj, 'editGroupId', item.id)
                this.$set(this.apiParamObj, 'title', item.title)
                this.$nextTick(() => {
                    if (this.$refs['edit-group'] && this.$refs['edit-group'].length) {
                        this.$refs['edit-group'][0].focus()
                    }
                })
            }
        },
        // 编辑分组
        async editGroupFn(id) {
            try {
                if (!this.apiParamObj.title) {
                    this.$set(this.varObj, 'editGroupId', -1)
                    this.$message.error('分组名称不可为空')
                    return
                }
                const curGroup = this.groupArr.find(item => item.id === id)
                if (curGroup && curGroup.title === this.apiParamObj.title) {
                    this.$set(this.varObj, 'editGroupId', -1)
                    return
                }
                this.loading.page = true
                await this.editServiceGroup({
                    groupId: id,
                    params: this.apiParamObj,
                })
                this.getServiceGroupFn()
                this.apiParamObj = {}
                this.$set(this.varObj, 'editGroupId', -1)
                this.loading.page = false
            } catch (error) {
                this.loading.page = false
            }
        },
        // 删除分组
        delGroupFn(id) {
            try {
                this.delServiceGroup({
                    groupId: id,
                }).then(() => {
                    this.$message.success('删除成功')
                    this.getServiceGroupFn()
                })
            // eslint-disable-next-line no-empty
            } catch (error) {}
        },
        updateApiParamObj(e = {}) {
            const {
                isNotXingTuApi, data, replace = false, isOffline = false,
            } = e
            if (replace) {
                this.apiParamObj = _.cloneDeep(data)
                return
            }
            if (!data) {
                let paramType = 'headers'
                this.apiParamObj = {
                    ...this.apiParamObj,
                    api: '',
                    name: '',
                    title: '',
                    remark: '',
                    url: '',
                    response: { ...this.apiParamObjResponseDefault },
                    querys: [],
                    body: {},
                    headers: [],
                    paths: [],
                }
                if (isOffline) {
                    this.apiParamObj.body = { object: {}, type: 'params', params: [] }
                    paramType = isOffline ? 'request' : paramType
                }
                this.$set(this.varObj, 'paramType', paramType)
                return
            }
            if (!isNotXingTuApi) {
                let body = {}
                if (data && data.body && data.body.type === 'object') {
                    body = data.body.object || { objectId: '' }
                }
                this.apiParamObj = {
                    ...this.apiParamObj,
                    title: data.title,
                    name: data.name,
                    url: data.url,
                    remark: data.remark,
                    method: data.method,
                    hasAuth: data.hasAuth,
                    querys: data.querys || [],
                    body: {
                        params: data.requestMetadata,
                        type: data?.body?.type || 'params',
                        object: {
                            ...body,
                        },
                        contentType: data.requestMetadata[0]?.contentType || data?.body?.contentType,
                    },
                    response: { ...this.apiParamObjResponseDefault, ...data.responseMetadata || {} },
                    headers: data.headers || [],
                    paths: data.paths,
                    version: data.version,
                }
            }
        },
        addIdToArr(arr) {
            if (!Array.isArray(arr)) return []
            return arr.map(item => {
                let { fields } = item
                if (Array.isArray(fields)) {
                    fields = this.addIdToArr(fields)
                }
                return {
                    ...item,
                    id: this.guid(),
                    fields,
                }
            })
        },
        changeFieldsHandle(row, value) {
            const fields = row.fields || []
            fields.forEach(item => {
                item.handle = value
                this.itemHandleChange(item)
                this.changeFieldsHandle(item, value)
            })
        },
        itemHandleChange(row) {
            this.disableChild(row, 'fields', row.handle === 'params' || row.handle === 'matching')
            if (row.index === 0 && row.handle === 'noHandle') {
                this.changeFieldsHandle(row, 'params')
            }
        },
        disableChild(obj, childName, disable) {
            const child = obj[childName]
            Array.isArray(child) && child.forEach(item => {
                item.disable = disable
                this.disableChild(item, childName, disable)
            })
        },
        getObjectField(row) {
            getObjectField({
                objectId: row.objectId,
            }).then(data => {
                const fields = row.items || []
                fields.forEach(item => {
                    item.handle = 'matching'
                    const index = data.findIndex(i => i.type === item.type && i.name === item.name)
                    if (index === -1) {
                        this.changeFieldsHandle(item, 'matching')
                        return
                    }
                    item.relevanceMsg = {
                        isMatching: true,
                        name: data[index].name,
                        title: data[index].title,
                    }
                    if (item.type === 'object' || item.type === 'objectArray') {
                        this.getObjectField({
                            objectId: data[index]?.relatedObject?.id,
                        })
                    }
                })
            })
        },
        formatBody(requestMetadata, body) {
            function formatObjectItem(schema) {
                return schema.map(item => {
                    const result = {
                        id: item.id,
                        name: item.name,
                        type: item.type,
                        title: item.name,
                        remark: item.remark,
                        handle: item.handle || '',
                        disable: !item.isRoot,
                        required: !!item.required,
                        relevanceMsg: {
                            isMatching: false,
                            name: '',
                            title: '',
                        },
                    }
                    if (item.objectId) {
                        result.objectId = item.objectId
                    }
                    if (Array.isArray(item.fields) && item.fields.length) {
                        result.fields = formatObjectItem(item.fields)
                    }
                    return result
                })
            }
            const formatParamsFields = fieldsArr => fieldsArr.map(item => {
                const { params } = body
                const index = params.findIndex(i => item.name === i.key)
                const result = {
                    id: item.id,
                    name: item.name,
                    type: item.type,
                    title: item.name,
                    remark: item.remark,
                    required: !!item.required,
                    handle: index === -1 ? 'noHandle' : 'params',
                    disable: false,
                    relevanceMsg: {
                        isMatching: false,
                        name: '',
                        title: '',
                    },
                }
                if (Array.isArray(item.fields) && item.fields.length) {
                    result.fields = formatObjectItem(item.fields)
                }
                if (['object', 'objectArray'].includes(result.type) && index !== -1) {
                    result.objectId = params[index].objectId
                    this.getObjectField(result)
                    this.getObjectDtlFn(result, result.objectId)
                }
                return result
            })
            const dataType = requestMetadata?.dataType
            if (isParamsType(dataType)) {
                return Array.isArray(requestMetadata.fields) ? requestMetadata.fields.map(item => {
                    const data = fieldTransform(item)
                    const { params } = body
                    if (Array.isArray(params) && params.find(d => d.key === (data.name || data.key))) {
                        data.handle = 'pair'
                    } else {
                        data.handle = ''
                    }
                    return data
                }) : []
            }
            if (body.type === 'object') {
                requestMetadata = [{
                    ...requestMetadata,
                    title: 'root',
                    name: 'postData',
                    type: 'object',
                    handle: 'params',
                    isRoot: true,
                    objectId: body.object.objectId,
                }]
                requestMetadata = formatObjectItem(this.addIdToArr(requestMetadata))
                const root = requestMetadata[0]
                this.getObjectField(root)
                this.getObjectDtlFn(root, root.objectId)
                return requestMetadata
            }
            const fields = formatParamsFields(this.addIdToArr(requestMetadata.fields))
            return [{
                fields,
                id: this.guid(),
                title: 'root',
                name: 'root',
                type: 'object',
                handle: 'noHandle',
                isRoot: true,
            }]
        },
        guid() {
            return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
                const r = Math.random() * 16 | 0
                // eslint-disable-next-line no-mixed-operators
                const v = c === 'x' ? r : (r & 0x3 | 0x8)
                return v.toString(16)
            })
        },
        // 获取服务类型名称
        getServiceType(serviceItem) {
            return serviceItem.isXingTu ? 'xingTuApi' : serviceItem.isOffline ? 'offlineService' : 'customCreate'
        },
        async editStarMap(type, item) {
            try {
                this.editLoadingId = item.id
                const { manageKey = '' } = this.xingtuInfo
                const mipApiDetail = await this.getMipApiDetail({
                    id: item.xingTuApiId, xingTuEnvId: item.xingTuEnvId, manageKey,
                })
                const data = {
                    headers: mipApiDetail.headers,
                    groupId: item.groupId || this.filterObj.groupId,
                    name: item.name,
                    url: item.url,
                    api: item.xingTuApiId,
                    method: item.method,
                    title: item.title,
                    isXingTu: item.isXingTu,
                    type: this.getServiceType(item),
                    hasAuth: !!mipApiDetail.hasAuth,
                    remark: item.remark || '',
                    response: item.response || {},
                    querys: mipApiDetail.querys || [],
                    paths: mipApiDetail.paths,
                }
                data.response.successCodeValue = String(data.response.successCodeValue)
                if (['object', 'objectArray'].includes(data.response.dataType)) {
                    data.response.schema = {
                        name: 'root',
                        title: 'root',
                        type: 'object',
                        id: this.guid(),
                        fields: this.addIdToArr(mipApiDetail.responseMetadata.fields),
                    }
                }
                if (data.method === 'get') {
                    data.body = item.body || {}
                } else {
                    data.body = {
                        params: this.formatBody(mipApiDetail.requestMetadata, item.body),
                        contentType: mipApiDetail.requestMetadata.dataType,
                        type: isParamsType(mipApiDetail.requestMetadata.dataType) ? 'params' : 'object',
                    }
                }
                this.apiParamObj = data
                this.editLoadingId = ''
                this.$set(this.varObj, 'serviceId', item.id)
                this.$set(this.varObj, 'optType', type)
                this.$set(this.varObj, 'paramType', 'headers')
                this.$nextTick(() => {
                    this.$set(this.varObj, 'optBool', true)
                })
            } catch (err) {
                this.editLoadingId = ''
                logger.log(err)
            }
        },
        replaceAppend(arr) {
            if (this.isTenantApp) {
                return arr.map(item => {
                    let reg = ''
                    if (item.addField) {
                        if (item.customizeType === 0) {
                            reg = new RegExp(`^${item.customizeField}`)
                        } else {
                            reg = new RegExp(`${item.customizeField}$`)
                        }
                        item.key = item.key.replace(reg, '')

                        if (this.isTenantApp && !this.apiParamObj.isTenant) {
                            item.customizeType =  this.validPurviewObject.customizeType
                            item.customizeField = this.validPurviewObject.customizeField
                        }
                    }
                    return item
                })
            }
            return arr
        },
        addServiceByType(item) {
            this.addServiceVisible = false
            this.$router.push({
                name: 'ServiceDetail',
                params: { type: item.key },
                query: {
                    group: this.filterObj.groupId,
                },
            })
        },
        openDialogFn(type, item) {
            this.$router.push({
                name: 'ServiceDetail',
                params: { type: 'type', id: item.id },
            })
        },

        getDefaultDomainVariableKey(url, isXingTu) {
            const defaultKey = isXingTu ? 'sys_mip_env' : 'sys_default_domain'
            if (url && /https?:\/\//.test(url)) {
                return ''
            }
            return defaultKey
        },

        getGroupServiceFnBySearch() {
            this.filterObj.page = 1
            this.getGroupServiceFn()
        },
        // 查询分组中的服务列表
        async getGroupServiceFn() {
            this.$set(this.loading, 'table', true)
            const { manageKey = '' } = this.xingtuInfo
            try {
                const resData = await this.getService({
                    ...this.filterObj,
                    xingTuEnvId: this.xingTuEnvId,
                    manageKey,
                })
                this.serviceArr = resData.items || []
                this.defaultServiceArr = _.cloneDeep(resData.items) || []
                this.$set(this.filterObj, 'total', resData.total)
                this.loading.table = false
                this.updateDesignerDataServiceList()
            } catch (error) {
                this.loading.table = false
            }
        },
        // 删除服务
        delServiceFn(row) {
            this.$confirm('服务删除后将无法恢复，确定删除？', {
                type: 'warning',
                title: '删除服务',
                customClass: 'confirm-box',
                roundButton: false,
            })
                .then(async () => {
                    try {
                        await this.delService({
                            serviceId: row.id,
                        })
                        this.$message.success('删除成功')
                        this.getGroupServiceFn()
                    // eslint-disable-next-line no-empty
                    } catch (error) {}
                })
                .catch(() => {})
        },
        handleSizeChange(val) {
            this.$set(this.filterObj, 'pageSize', val)
            this.getGroupServiceFn()
        },
        handleCurrentChange(val) {
            this.$set(this.filterObj, 'page', val)
            this.getGroupServiceFn()
        },
        async getObjectDtlFn(obj, id) {
            if (!id) {
                return
            }
            try {
                const resData = await this.getObjectDtl({
                    objectId: id,
                })
                this.$set(obj, 'objectName', resData.title)
            // eslint-disable-next-line no-empty
            } catch (error) {}
        },
        // 更改业务对象
        onChangeBusinessEnvId(val) {
            this.businessEnvId = val
            this.loading.page = true
            this.getServiceGroupFn()
        },
        // 导入服务
        async onImportEvent(option) {
            try {
                await this.importService({
                    webappId: this.appId,
                    ...this.commonParams,
                    params: { fromEnvId: option.importBusinessEnvId, toEnvId: option.targetBusinessEnvId, category: option.category },
                })
                this.getServiceGroupFn()
            } catch (error) {
                logger.log(error)
            }
        },
        getAllEnvListCallBack(env) {
            if (Array.isArray(env) && env.length) {
                const [cur] = env
                this.onChangeBusinessEnvId(cur.id)
            }
        },
        onReset() {
            if (this.apiParamObj.body && this.apiParamObj.body.object) {
                this.apiParamObj.body.object.objectId = ''
            }
            if (this.apiParamObj.body.params) {
                this.apiParamObj.body.params = []
            }
            this.apiParamObj.method =  this.apiParamObj.type === 'offlineService' ? 'local' : 'get'
            this.apiParamObj.response.objectId = ''
        },
        updateApiInfo(data) {
            const needUpdate = data.length > 0
            this.updateInfo = {
                // icon
                icon: needUpdate ? SuccessIcon : DefaultWarningIcon,
                text: needUpdate ? '更新完成' : '暂无需要更新的api',
                success: 0,
                fail: 0,
            }
        },

        handleUpdateDialogClose(done) {
            clearTimeout(this.updateApiTimer)
            done()
        },

        showUpdateApiDialog() {
            this.updateApiVisible = true
            this.updateInfo = DEFAULT_UPDATE_API_INFO
            this.getUpdateStarApiList()
        },

        // 通过updateStarMipApiList，获取需要更新的服务列表
        async getUpdateStarApiList() {
            this.updateApiLoading = true
            const { manageKey = '' } = this.xingtuInfo
            try {
                const res = await this.updateStarMipApiList({
                    appId: this.appId,
                    xingTuEnvId: this.xingTuEnvId,
                    manageKey,
                })

                this.updateApiList = res
                this.updateApiInfo(res)
                this.updateApiListFn()
            } catch (error) {
                console.log(error)
                this.updateApiLoading = false
                this.updateApiVisible = false
            }
        },

        // 根据updateApiList，每隔 1s 通过updateStarMipApi更新一个api, 直到全部更新完成
        async updateApiListFn() {
            const { updateApiList }  = this
            const { manageKey = '' } = this.xingtuInfo

            const len = updateApiList.length
            let i = 0

            // 使用setTimeout模拟setInterval
            const updateApi = () => {
                if (i < len) {
                    this.updateStarMipApi({
                        apiServiceId: updateApiList[i],
                        xingTuEnvId: this.xingTuEnvId,
                        manageKey,
                    })
                        .then(res => {
                            if (res < 2) {
                                this.updateInfo.success++
                            } else {
                                this.updateInfo.fail++
                            }
                            i++
                            this.updateTimer = setTimeout(updateApi, 1000)
                        })
                        .catch(() => {
                            this.updateInfo.fail++
                            i++
                            this.updateTimer = setTimeout(updateApi, 1000)
                        })
                } else {
                    clearTimeout(this.updateTimer)
                    this.updateApiLoading = false
                }
            }
            updateApi()
        },

        handleUpdateSuccess() {
            this.updateApiVisible = false
            if (this.updateApiList.length > 0) {
                this.getGroupServiceFnBySearch()
            }
        },
    },
}
</script>

<style lang="less" scoped>
.service-manage-ctn {
    width: 100%;
    height: 100%;
}
.service-manage {
    width: 100%;
    height: calc(100% - 36px);
    display: flex;
    flex-direction: row;
    padding: 16px 20px;
    overflow: hidden;
    .service-group{
        width: 200px;
        border-radius: 3px;
        background: rgba(255,255,255,1);
        box-shadow: 0 0 2px 0 rgba(0,0,0,0.12);
        margin-right: 16px;
    }
    .service-list{
        flex: 1;
        overflow: hidden;
        box-shadow: 0 0 2px 0 rgba(0,0,0, 0.12);
        height: auto;
        background: #fff;
        border-radius: 3px;
        padding: 0 16px;
        &-header{
            height: 48px;
            display: flex;
            align-items: center;
            &-H1{
                flex: 1;
                color: #222222;
                font-size: 12px;
                font-weight: 700;
                line-height: 20px;
            }
            &-search{
                width: 200px;
                /deep/ .hc-input {
                    font-size: 12px;
                }
            }
            &-spliter{
                width: 1px;
                height: 28px;
                background: #E9EBEE;
                margin: 0 16px;
            }
            &-mock{
                margin-right: 8px;
            }
            &-add{
                /deep/ .hc-button{
                    border-color: #266EFF;
                    color: #266EFF;
                    font-size: 12px;
                }
            }
            &-update {
                margin-right: 16px;
                font-size: 12px;
            }
        }
        .decollator{
            width: 1px;
            height: 10px;
            background: #E9EBEE;
            display: inline-block;
            margin: 0 8px;
        }
        /deep/ .hc-table th.hc-table__cell{
            background: #FBFBFB;
            >.cell{
                padding-left: 12px;
                font-size: 13px;
                font-size: 13px;
                font-weight: 400;
                color: #666666;
                line-height: 22px;
            }
        }
        /deep/ .hc-table .cell{
            padding-left: 12px;
        }

        .table-wrapper{
            &__no-data{
                &.hc-table::before{
                    display: none;
                }
            }
            &--displayname {
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
            }
        }
        .pagination-wrapper{
            margin-bottom: 16px;
        }
    }
}
.table-empty{
    padding: 16px 0 24px 0;
    img {
        width: 92px;
        height: 92px;
    }
    &-tip{
        font-size: 14px;
        line-height: 22px;
        color: #999999;
    }
    &-button{
        cursor: pointer;
        color: #266EFF;
    }
}

</style>
<style lang="less">
.add-service-modal{
    display: flex;
    &-item{
        height: 242px;
        margin-right: 16px;
        flex: 1;
        display: flex;
        align-items: center;
        flex-direction: column;
        padding: 16px;
        border-radius: 3px;
        cursor: pointer;
        border: 1px solid rgba(233,235,238,1);
        transition: all 0.3s;
        &:hover{
            border: 1px solid rgba(38,110,255,1);
            background: rgba(38,110,255,0.08);
            box-shadow: 0 2px 4px 0 rgba(0,0,0,0.2);
            transition: all 0.3s;
        }
        &:last-child{
            margin: 0;
        }
        .img{
            width: 120px;
            height: 120px;
            margin-bottom: 24px;
        }
        .title{
            color: #222222;
            font-size: 14px;
            font-weight: 700;
            line-height: 22px;
            margin-bottom: 4px;
        }
        .des{
            color: #666666;
            font-size: 12px;
            font-weight: 400;
            line-height: 20px;
            text-align: center;
        }
    }
}
.add-service-modal-footer {
    margin-top: 4px;
    font-size: 14px;
    text-align: center;
}

.service-manage-ctn__update-dialog {
    .hc-dialog {
        padding-bottom: 20px;
    }
    .hc-dialog__body {
        height: 200px;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .hc-dialog__footer {
        display: none;
    }

    .update-loading {
        color: #666666;
        font-size: 12px;
        font-weight: 400;
        line-height: 20px;
        display: flex;
        flex-direction: column;
        align-items: center;
        .el-icon-loading {
            font-size: 32px;
            color: #266EFF;
            margin-bottom: 8px;
            width: 32px;
            height: 32px;
        }
    }

    .update-success {
        display: flex;
        flex-direction: column;
        align-items: center;
        > img {
            display: block;
            width: 50px;
            height: 50px;
            margin-bottom: 24px;
        }

        &-tip{
            color: #333333;
            font-size: 16px;
            font-weight: 500;
            margin-bottom: 4px;
        }
        &-num {
            color: #999999;
            font-size: 14px;
            font-weight: 400;
            line-height: 22px;
            margin-bottom: 24px;
        }

        &--empty {
            .update-success-btn .hc-button {
                margin-top: 50px;
            }
        }

        &-btn {
            .hc-button {
                font-size: 13px;
                width: 80px;
                height: 32px;
            }
        }
    }
}
</style>>
